export default __webpack_public_path__ + "static/media/UCSD_Logo.c53e1045.png";